//import React from "react";
//New change 2026-08-27 : Anuj - For mobile cards navigation
import React, { useEffect, useRef, useState } from "react";
import styles from "../../styles/pricingSection.module.css";

/**
 * PricingSection
 * Expands below CampaignBanner's footer band when "料金詳細を見る" is clicked.
 * Content is sourced from the L1/L2/L3 managed-service package pricing table.
 *
 * Props:
 *  - sectionId: string — unique DOM id for the outer wrapper, generated by
 *      the parent CampaignBanner via useId(). This page renders several
 *      CampaignBanner instances, each with its own PricingSection, so a
 *      hardcoded id would be duplicated across the page — breaking
 *      aria-controls on the toggle button and making
 *      document.getElementById() (used for the mobile auto-scroll) always
 *      resolve to the FIRST instance instead of the one the user clicked.
 *  - isOpen: boolean — controls the expand/collapse animation
 *  - onCollapse: () => void — called by the bottom "閉じる" button;
 *      the parent (CampaignBanner) closes the section and scrolls back up.
 */

/* --- Small inline icons for category rows (監視/通知/運用) ------------- */

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
    <path
      d="M12 3l7 3v5.5c0 4.5-3 7.7-7 9-4-1.3-7-4.5-7-9V6l7-3z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M9 12.2l2 2 4-4.4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BellIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
    <path
      d="M6 10.5a6 6 0 1112 0c0 2.6.7 4.2 1.6 5.4.3.4 0 1-.5 1H4.9c-.5 0-.8-.6-.5-1C5.3 14.7 6 13.1 6 10.5z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 19a2.5 2.5 0 005 0"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const GearIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
    <path
      d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

/* --- icons for mobile cards navigation < & > ------------- */
 
const LeftIcon = () => (
<svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
>
<path
      d="M12.5 4.5L5 10L12.5 15.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
</svg>
);
 
const RightIcon = () => (
<svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
>
<path
      d="M7.5 4.5L15 10L7.5 15.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
</svg>
);

const PLANS = [
  {
    id: "l1",
    name: "ベーシック(L1)",
    tagline: "監視・通知",
    description:
      "チケット管理と日次レポートによる進捗報告を標準化した、安心の一次窓口プラン",
    price: "98,000",
    color: "colOrange",
  },
  {
    id: "l2",
    name: "スタンダード(L2)",
    tagline: "標準保守・運用",
    description:
      "24時間チャット通知に加え定期パッチ適用や脆弱性スキャンまで標準装備したプラン",
    price: "198,000",
    color: "colGreen",
  },
  {
    id: "l3",
    name: "アドバンスド(L3)",
    tagline: "高度自動化・分析",
    description:
      "インフラ監視にとどまらず、夜間の「バッチ再実行」や「SQL修正・抽出」など、\nシステムの保守・データ運用業務まで幅広く一括代行するプラン",
    price: "298,000",
    color: "colBlue",
  },
];

const CATEGORIES = [
  {
    label: "監視・検知",
    icon: ShieldIcon,
    rows: [
      { feature: "アラートの受信・確認", l1: "〇 ※1", l2: "〇", l3: "〇" },
      { feature: "初期切り分け・一次対応（L1）", l1: "〇", l2: "〇", l3: "〇" },
      {
        feature: "サーバヘルスチェック（1時間毎）\n（CPU/メモリ/ディスク/サービス稼働状況）",
        l1: "ー",
        l2: "〇",
        l3: "〇",
      },
      { feature: "バッチジョブ監視（完了/失敗/遅延）", l1: "ー", l2: "ー", l3: "〇" },
    ],
  },
  {
    label: "通知・報告",
    icon: BellIcon,
    rows: [
      { feature: "関連チームへのエスカレーション", l1: "〇", l2: "〇", l3: "〇" },
      { feature: "日次レポート提出（シフト内の対応整理）", l1: "〇", l2: "〇", l3: "〇" },
      { feature: "障害通知（チャット/メール等）", l1: "〇", l2: "〇", l3: "〇" },
      { feature: "ログ取得（定期／オンデマンド）", l1: "ー", l2: "〇", l3: "〇" },
      { feature: "サーバ性能レポート（週次／月次）", l1: "ー", l2: "ー", l3: "〇" },
      { feature: "メンテナンス影響分析・レポート作成", l1: "ー", l2: "ー", l3: "〇" },
    ],
  },
  {
    label: "運用・保守",
    icon: GearIcon,
    rows: [
      {
        feature: "チケット管理\n（受付/ステータス更新/コメント/クローズ等）",
        l1: "〇 ※2",
        l2: "〇 ※2",
        l3: "〇",
      },
      { feature: "Windows／Linux パッチ適用", l1: "ー", l2: "〇", l3: "〇" },
      { feature: "脆弱性スキャンおよび事後確認", l1: "ー", l2: "〇 ※3", l3: "〇" },
      { feature: "運用プロセスの自動化（スクリプト化等）", l1: "ー", l2: "ー", l3: "〇" },
      { feature: "バッチジョブ再実行", l1: "ー", l2: "ー", l3: "〇" },
      { feature: "SQLデータ抽出・データパッチ（修正）", l1: "ー", l2: "ー", l3: "〇" },
    ],
  },
];

const PricingSection = ({ sectionId, isOpen, onCollapse }) => {
  //New change 2026-08-27 : Anuj - For mobile cards naviagtion
  //-----------------------------------------------------------
  const mobilePlansRef = useRef(null);
  const [activePlan, setActivePlan] = useState(0);

  const scrollToPlan = (index) => {
    const container = mobilePlansRef.current;
    if (!container) return;

    const card = container.children[index];
    if (!card) return;

    container.scrollTo({
      left: card.offsetLeft - container.offsetLeft,
      behavior: "smooth",
    });

  };

  const goToPreviousPlan = () => {
    scrollToPlan(Math.max(activePlan - 1, 0));
  };

  const goToNextPlan = () => {
    scrollToPlan(Math.min(activePlan + 1, PLANS.length - 1));
  };

  useEffect(() => {
    const container = mobilePlansRef.current;
    if (!container) return;

    const handleScroll = () => {
      const cards = Array.from(container.children);
      if (!cards.length) return;

      const containerCenter =
        container.scrollLeft + container.clientWidth / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const distance = Math.abs(cardCenter - containerCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      setActivePlan(closestIndex);
    };

    container.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);
  //-----------------------------------------------------------

  return (
    <div
      id={sectionId}
      className={`${styles.pricingSection} ${isOpen ? styles.open : ""}`}
      aria-hidden={!isOpen}
    >
      <div className={styles.inner}>
        {/* Title bar — company / service name */}
        <div className={styles.titleBar}>
          DGフューチャーテックインディアのマネージドサービス
        </div>

        <div className={styles.content}>
          {/* Header */}
          <div className={styles.header}>
            <p className={styles.eyebrow}>
              オフショア体制による、時間帯一律の安心パッケージ価格
            </p>
            <p className={styles.headerNote}>
              本料金は、日中・夜間・深夜どの時間帯（1シフト＝8時間）をお選びいただいても追加料金はありません。
              <br />
              （「夜間・深夜割増」は一切ございません）
              <br />
              また、オンプレミス・クラウドなど、対象のインフラ環境を問わず一律のパッケージ価格でご提供いたします。
            </p>
          </div>

          {/* Table */}
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <colgroup>
                <col className={styles.colCategory} />
                <col className={styles.colFeature} />
                <col className={styles.colPlan} />
                <col className={styles.colPlan} />
                <col className={styles.colPlan} />
              </colgroup>
              <thead>
                <tr>
                  <th className={styles.cornerCell} colSpan={2} scope="col">
                    サービス名
                  </th>
                  {PLANS.map((plan) => (
                    <th
                      key={plan.id}
                      scope="col"
                      className={`${styles.planCell} ${styles[plan.color]}`}
                    >
                      {plan.name}
                    </th>
                  ))}
                </tr>
                <tr>
                  <th className={styles.cornerCell} colSpan={2} scope="col">
                    主なサービス内容
                  </th>
                  {PLANS.map((plan) => (
                    <td
                      key={plan.id}
                      className={`${styles.planContent} ${styles[plan.color]}`}
                    >
                      <span className={styles.planTag}>{plan.tagline}</span>
                      <span className={styles.planDesc}>
                        {plan.description}
                      </span>
                    </td>
                  ))}
                </tr>
                <tr className={styles.priceRow}>
                  <th className={styles.cornerCell} colSpan={2} scope="col">
                    月額料金
                    <span className={styles.priceCondition}>
                      （全時間帯同一価格、1シフト/1〜5台のサーバ、オンプレ・クラウド共通
）
                    </span>
                  </th>
                  {PLANS.map((plan) => (
                    <td
                      key={plan.id}
                      className={`${styles.price} ${styles[plan.color]}`}
                    >
                      <span className={styles.priceAmount}>{plan.price}</span>
                      <span className={styles.priceUnit}>円/月（税別）</span>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {CATEGORIES.map((cat) => {
                  const CatIcon = cat.icon;
                  return cat.rows.map((row, idx) => (
                    <tr key={`${cat.label}-${idx}`}>
                      {idx === 0 && (
                        <th
                          rowSpan={cat.rows.length}
                          className={styles.categoryCell}
                          scope="rowgroup"
                        >
                          <span className={styles.categoryIconWrap}>
                            <CatIcon />
                          </span>
                          <span className={styles.categoryLabel}>
                            {cat.label}
                          </span>
                        </th>
                      )}
                      <th className={styles.featureCell} scope="row">
                        {row.feature.split("\n").map((line, i) => (
                          <React.Fragment key={i}>
                            {i > 0 && <br />}
                            {line}
                          </React.Fragment>
                        ))}
                      </th>
                      <td className={`${styles.check} ${styles.colOrange}`}>
                        {row.l1}
                      </td>
                      <td className={`${styles.check} ${styles.colGreen}`}>
                        {row.l2}
                      </td>
                      <td className={`${styles.check} ${styles.colBlue}`}>
                        {row.l3}
                      </td>
                    </tr>
                  ));
                })}
              </tbody>
            </table>
          </div>

          {/* New change 2026-08-27 - Anuj : Pricing plan responsive layout & Navigation strip */}
          {/* ---------------------------------------------------------------- */}
          
          {/* Mobile plan navigation controls */}
          <div className={styles.mobilePlanNavigation}>
            <button
              type="button"
              onClick={goToPreviousPlan}
              disabled={activePlan === 0}
              aria-label="前のプラン"
            >
              <LeftIcon />
            </button>

            <div className={styles.mobilePlanDots}>
              {PLANS.map((plan, index) => (
              <button
                key={plan.id}
                type="button"
                className={`${styles.planDot} ${
                  index === activePlan ? styles.activeDot : ""
                } ${styles[plan.color]}`}
                onClick={() => scrollToPlan(index)}
                aria-label={`${plan.name}を表示`}
              />
            ))}
            </div>

            <button
              type="button"
              onClick={goToNextPlan}
              disabled={activePlan === PLANS.length - 1}
              aria-label="次のプラン"
            >
              <RightIcon />
            </button>
          </div>

          <div
            className={styles.mobilePlans}
            ref={mobilePlansRef}
          >
            {PLANS.map((plan) => (
              <div
                key={plan.id}
                className={`${styles.mobilePlanCard} ${styles[plan.color]}`}
              >
                <h3>{plan.name}</h3>

                <div className={styles.mobilePlanTag}>
                  {plan.tagline}
                </div>

                <p className={styles.mobilePlanDescription}>
                  {plan.description}
                </p>

                <div className={styles.mobilePlanPrice}>
                  <span>{plan.price}</span>
                  <small>円/月（税別）</small>
                </div>

                {CATEGORIES.map((cat) => {
                  const CatIcon = cat.icon;
                  const planKey = plan.id;

                  return (
                    <div key={cat.label} className={styles.mobileCategory}>
                      <div className={styles.mobileCategoryTitle}>
                        <CatIcon />
                        <span>{cat.label}</span>
                      </div>

                      {cat.rows.map((row, index) => (
                        <div
                          key={`${cat.label}-${index}`}
                          className={styles.mobileFeature}
                        >
                          <span>{row.feature}</span>
                          <strong>{row[planKey]}</strong>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          {/* ---------------------------------------------------------------- */}

          {/* Footnotes + scale-up note, side by side */}
          <div className={styles.notesGrid}>
            <div className={styles.footnotes}>
              <p>※1 アラート対応ボリュームは1シフトあたり20件までとなります。</p>
              <p>※2 チケット対応ボリュームは1シフトあたり20件までとなります。</p>
              <p>※3 脆弱性スキャンの対象は5台〜となります。</p>
              <p>
                ※対象インフラ：オンプレミス環境、各種クラウド環境（AWS / Azure /
                GCP等）のいずれも同一料金で対応可能です。
              </p>
            </div>

            <div className={styles.scaleNote}>
              <p>
                サーバ数が6台以上の場合や、2シフト（16時間監視）、
                <strong>3シフト（24時間365日フルタイム監視）</strong>
                への拡張も、割増なしの明瞭な料金テーブル（最大100台まで対応）をご用意しております。
                <br />
                まずはお気軽にお問い合わせください。パッケージをカスタマイズする個別のご相談にも対応可能です。
              </p>
            </div>
          </div>

          {/* Collapse control — brings the user back to the top of the banner */}
          <div className={styles.collapseRow}>
            <button
              type="button"
              className={styles.collapseButton}
              onClick={onCollapse}
            >
              閉じる <span className={styles.collapseArrow}>▲</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingSection;